/**
 * Book Worksheet configuration
 * Imports and re-exports the main application configuration
 */

import { config as appConfig } from '../../constants/config';

// Export the main application configuration
export const config = appConfig;

// Book Worksheet specific configuration
export const bookWorksheetConfig = {
  // UI Configuration
  ui: {
    // Default tab index
    defaultTabIndex: 0,

    // Tab names
    tabs: {
      litGroups: 'Literary Groups',
      books: 'Books',
      characters: 'Characters',
      variations: 'Variations'
    },

    // Form modes
    formModes: {
      create: 'create',
      edit: 'edit',
      view: 'view'
    },

    // Status options for entities
    statusOptions: [
      { key: 'active', text: 'Active', value: 'active' },
      { key: 'draft', text: 'Draft', value: 'draft' },
      { key: 'archived', text: 'Archived', value: 'archived' },
      { key: 'deleted', text: 'Deleted', value: 'deleted' }
    ],

    // Priority options for entities
    priorityOptions: [
      { key: 'high', text: 'High', value: 'high' },
      { key: 'medium', text: 'Medium', value: 'medium' },
      { key: 'low', text: 'Low', value: 'low' }
    ]
  },

  // Default values for new entities
  defaults: {
    litGroup: {
      name: '',
      description: '',
      type: 'series',
      status: 'active'
    },
    book: {
      title: '',
      description: '',
      author: '',
      series: '',
      status: 'active',
      priority: 'medium',
      deadline: null,
      bookCover: null
    },
    character: {
      name: '',
      description: '',
      avatarUrl: '/narrator_1-1-480x490.png',
      status: 'active',
      priority: 'medium',
      gender: '',
      age: '',
      personality: '',
      background: '',
      notes: ''
    },
    variation: {
      name: '',
      description: '',
      status: 'active',
      audioUrl: null,
      notes: ''
    }
  },

  // Validation schemas
  validation: {
    // Minimum and maximum lengths for text fields
    minNameLength: 2,
    maxNameLength: 100,
    maxDescriptionLength: 1000,
    maxNotesLength: 2000
  }
};

export default config;
